import React, { useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { XIcon } from 'lucide-react';
interface LegalModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
}
export function LegalModal({
  isOpen,
  onClose,
  title,
  children
}: LegalModalProps) {
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => {
      document.body.style.overflow = '';
    };
  }, [isOpen]);
  useEffect(() => {
    const handleEsc = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    if (isOpen) window.addEventListener('keydown', handleEsc);
    return () => window.removeEventListener('keydown', handleEsc);
  }, [isOpen, onClose]);
  return <AnimatePresence data-id="element-13">
      {isOpen && <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} exit={{
      opacity: 0
    }} transition={{
      duration: 0.2
    }} className="fixed inset-0 z-50 flex items-center justify-center p-4 md:p-8" onClick={onClose} role="dialog" aria-modal="true" aria-label={title} data-id="element-14">
          {/* Backdrop */}
          <div className="absolute inset-0 bg-black/70 backdrop-blur-sm" data-id="element-15" />

          {/* Modal */}
          <motion.div initial={{
        opacity: 0,
        y: 20,
        scale: 0.97
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 10,
        scale: 0.97
      }} transition={{
        duration: 0.25,
        ease: [0.22, 1, 0.36, 1]
      }} onClick={e => e.stopPropagation()} className="relative z-10 w-full max-w-2xl max-h-[80vh] bg-bg-card border border-white/10 rounded-xl shadow-2xl shadow-black/50 flex flex-col overflow-hidden" data-id="element-16">
            {/* Header */}
            <div className="flex items-center justify-between px-6 py-4 border-b border-white/10 flex-shrink-0" data-id="element-17">
              <h2 className="font-heading font-bold text-lg text-text-primary" data-id="element-18">
                {title}
              </h2>
              <button onClick={onClose} className="p-2 rounded-lg text-text-muted hover:text-text-primary hover:bg-white/5 transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-teal/50" aria-label="Cerrar" data-id="element-19">
                <XIcon className="w-5 h-5" data-id="element-20" />
              </button>
            </div>

            {/* Content */}
            <div className="px-6 py-6 overflow-y-auto text-text-secondary text-sm leading-relaxed space-y-4" data-id="element-21">
              {children}
            </div>
          </motion.div>
        </motion.div>}
    </AnimatePresence>;
}